<template>
  <div class="homapt-button-wrapper" v-on:click="loginGoogle">
    <loading :active.sync="loading"></loading>
    <i class="fab fa-google"></i>
    <p class="homapt-social-button-text"></p>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  data () {
    return {
      loading: false
    }
  },
  components: {
    Loading
  },
  methods: {
    ...mapActions([
      'authenticatedLogin'
    ]),
    async loginGoogle () {
      this.loading = true
      var authData = {
        idProvider: 'google'
      }
      try {
        await this.authenticatedLogin(authData)
      } catch (error) {
        console.log(error)
      }
      this.loading = false
    }
  }
}
</script>

<style scoped>
.fab {
  padding: 10px;
  padding-top: 12px !important;
  font-size: 1rem;
  text-align: center;
  text-decoration: none;
  width: 5rem;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  display: inline;
}

.homapt-button-wrapper {
  margin: 5px 2px;
  border-radius: 5px;
  background-color: #dd4b39;
  cursor: pointer;
  padding-top: 8px;
  padding-bottom: 8px;
  text-align: center;
}

.homapt-button-wrapper {
  box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.2);
}

.homapt-button-wrapper:active {
  box-shadow: none;
}

.homapt-social-button-text {
  color: white !important;
  margin-top: auto;
  margin-bottom: auto;
  display: inline;
}

.fa-google {
  color: white;
}

@media (max-width: 992px) {
  .homapt-social-button-text::after {
    content: "Google";
  }
}

@media (min-width: 992px) {
  .homapt-social-button-text::after {
    content: "Login with Google";
  }
}
</style>



// WEBPACK FOOTER //
// src/components/authentication/GoogleButton.vue